const manifest = {
  '': () => import('./messages'),
  'ar': () => import('./messages_ar'),
  'cs': () => import('./messages_cs'),
  'da': () => import('./messages_da'),
  'de': () => import('./messages_de'),
  'el': () => import('./messages_el'),
  'es': () => import('./messages_es'),
  'fi': () => import('./messages_fi'),
  'fr': () => import('./messages_fr'),
  'he': () => import('./messages_he'),
  'hr': () => import('./messages_hr'),
  'hu': () => import('./messages_hu'),
  'it': () => import('./messages_it'),
  'iw': () => import('./messages_iw'),
  'ja': () => import('./messages_ja'),
  'ko': () => import('./messages_ko'),
  'nb': () => import('./messages_nb'),
  'nl': () => import('./messages_nl'),
  'no': () => import('./messages_no'),
  'pl': () => import('./messages_pl'),
  'pt-BR': () => import('./messages_pt-BR'),
  'pt': () => import('./messages_pt'),
  'ru': () => import('./messages_ru'),
  'sh': () => import('./messages_sh'),
  'sk': () => import('./messages_sk'),
  'sl': () => import('./messages_sl'),
  'sr': () => import('./messages_sr'),
  'sv': () => import('./messages_sv'),
  'th': () => import('./messages_th'),
  'tr': () => import('./messages_tr'),
  'zh-Hans': () => import('./messages_zh-Hans'),
  'zh-Hant': () => import('./messages_zh-Hant'),
};
export default manifest;
